// Vendors
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import { withNamespaces } from 'react-i18next';
import { PlutoLogo } from '../styles/loading';

// Components
import { checkMobileOperatingSystem } from '../utils/checkMobileOperatingSystem';
import LocalizedNotification from './LocalisedNotification';

const ANDROID_STORE_URL =
  process.env.ANDROID_STORE_URL || 'https://play.google.com/store/apps/details?id=tv.pluto.android';

const IOS_STORE_URL =
  process.env.IOS_STORE_URL ||
  'https://apps.apple.com/us/app/pluto-tv-live-tv-and-movies/id751712884';

const PlutoLogoStyled = styled(PlutoLogo)`
  width: 190px;
  margin-top: 4vh;
`;

const NotificationContainer = styled.div`
  background: linear-gradient(
    -180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 24%,
    rgb(0, 0, 0) 67%,
    rgb(0, 0, 0) 100%
  );
  width: 100%;
  min-height: calc(100% - (56.25vw + 66px));
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 100;
  margin: 0 auto;
  text-align: center;
`;

const AdVerbiage = styled.div`
  color: rgb(255, 255, 255);
  font-family: 'Pluto Sans SemiBold';
  font-size: 35px;
  letter-spacing: 0;
  position: relative;
  width: 90%;
  margin: 0 auto;
  margin-top: 12vh;
`;

const ContinueOnWeb = styled.div`
  color: rgb(234, 234, 234);
  font-family: 'Pluto Sans SemiBold';
  font-size: 14px;
  letter-spacing: 0;
  padding-bottom: 20px;
  padding-top: 10px;
`;

const Yellow = styled.div`
  color: rgb(255, 255, 59);
  font-size: 18px;
  font-family: 'Pluto Sans SemiBold';
  line-height: 20px;
`;

const COWClickable = styled.div`
  display: inline-block;
`;

const GetTheApp = styled.div`
  margin: 4vh 0px 10px 0px;
`;

// eslint-disable-next-line no-unused-vars
const styles = (theme) => ({
  button: {
    backgroundColor: '#FFEB3B',
    color: 'black',
    padding: '8px 37px',
    marginTop: '15px',
    fontSize: '16px',
    borderRadius: 30,
  },
});

class DownaloadAppNotification extends PureComponent {
  static propTypes = {
    inWelcomeScreen: PropTypes.bool.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    classes: PropTypes.shape({}).isRequired,
    showNotificationForced: PropTypes.bool,
    getAppBannerDismissed: PropTypes.bool.isRequired,
    dismissGetAppBanner: PropTypes.func.isRequired,
    appLoaded: PropTypes.bool,
    marketingRegion: PropTypes.string,
  };

  static defaultProps = {
    appLoaded: false,
    showNotificationForced: false,
    marketingRegion: 'us',
  };

  constructor(props) {
    super(props);
    const { isIos, isAndroid } = checkMobileOperatingSystem();
    if (isIos || isAndroid) {
      this.appUrl = `${isIos ? IOS_STORE_URL : ANDROID_STORE_URL}`;
    }
    this.state = {
      checked: true,
      getAppBannerDismissed: props.getAppBannerDismissed,
    };
  }

  componentDidUpdate(prevProps) {
    if (!this.state.getAppBannerDismissed && prevProps.appLoaded !== this.props.appLoaded) {
      this.props.dismissGetAppBanner();
    }
  }

  handleContinueOnWebClick = () => {
    this.setState({ checked: false });
  };

  dropInText = () => {
    const { t, i18n } = this.props;
    let text = "Drop in. It's free.";
    if (i18n.language.includes('es')) {
      text = '¡Es gratis!';
    } else if (i18n.language.includes('fr')) {
      text = "Streamez, c'est gratuit.";
    } else if (t('drop_in_its_free') !== 'drop_in_its_free') {
      text = t('drop_in_its_free');
    }
    return text;
  };

  render() {
    const {
      classes,
      inWelcomeScreen,
      isEmbed,
      showNotificationForced,
      t,
      i18n,
      marketingRegion,
    } = this.props;
    const language = i18n.language || 'en';

    if (isEmbed) {
      return null;
    }

    if (!showNotificationForced) {
      if (!this.appUrl || this.state.getAppBannerDismissed || inWelcomeScreen) return null;
    }

    return (
      <Slide direction="up" in={this.state.checked} mountOnEnter unmountOnExit>
        <NotificationContainer>
          <LocalizedNotification language={language} marketingRegion={marketingRegion} />
          <PlutoLogoStyled alt="Pluto TV logo" path="images/logoSplash.svg" />
          <Yellow>{this.dropInText()}</Yellow>
          <GetTheApp>
            <Button
              variant="contained"
              size="small"
              color="primary"
              href={this.appUrl}
              className={classes.button}
            >
              {t('get_the_app')}
            </Button>
          </GetTheApp>
          <ContinueOnWeb>
            <COWClickable onClick={this.handleContinueOnWebClick}>
              {t('continue_on_web')}
            </COWClickable>
          </ContinueOnWeb>
        </NotificationContainer>
      </Slide>
    );
  }
}

export const DownaloadAppNotificationComponent = withStyles(styles)(
  withNamespaces()(DownaloadAppNotification),
);
